import React from "react";
import Desktop_Header from "./Desktop_Header";
import Mobile_Header from "./Mobile_Header";
import useScrollPosition from "../../common/useScrollPosition";
import { useNavigate } from "react-router-dom";

function RenderHeader({ variant, page, className, onLogout, ...otherProps }) {
    let links = {
        "HOME": "/",
        "ABOUT": "/about",
        // "ROADMAP": "/roadmap",
        // "PLAYERS": "/players",
        "CAREERS": "/career",
        // "WORLD CHAMPIONSHIP": window.location.protocol + "//" + window.location.host + "/worldcup",
        "BLOG": "https://hitwicket.com/worldcup/blogs",
        // "HITSTATS": "/hitstats/login",
        "PAVILION": "/pavilion",
        "E-SPORTS": {
            "HITWICKET PREMIER LEAGUE": "/HPL",
            "YOUTH CHAMPIONSHIP": "/yc",
            "EMERGING YOUTH CHAMPIONSHIP": "/eyc",
            "CORPORATE TOURNAMENT": "/corporate-tournament",
            "CREATOR'S PROGRAM": "/creator-program",
            "ALLIANCE BATTLE ROYALE": "/alliance-battle-royale",
        },
        // "GAME INFO": {
        //     "TEAM STATS": "/match-info",
        // }
        // "PATH OF LEGENDS": window.location.protocol + "//" + window.location.host + "/worldcup/path-of-legends/leaderboard",
        // "CAREERS":{
        //     "OPEN POSITIONS": "/career",
        //     "LIFE AT HITWICKET": "/life-at-hitwicket",
        // },
    };

    if (page === "hcl") {
        links = {
            "HOME": "/hcl",
            "CITIES": "/hcl-cities",
            "SCHEDULE": "/hcl-schedule",
            // "discord": "/discord",
            "GUIDELINES": "/hcl-guidelines",
        };
    } else if (page === "igdc") {
        links = {
            "HOW TO PLAY": "#IGDC-Section2"
        };
    } else if (page === "yc") {
        links = {
            "HOME": "/yc",
            "SCHEDULE": "/yc-schedule",
            "GUIDELINES": "/yc-guidelines",
        };
    } else if (page === "eyc") {
        links = {
            "HOME": "/eyc",
            "SCHEDULE": "/eyc-schedule",
            "GUIDELINES": "/eyc-guidelines",
        };
    } else if (page === "hitstats") {
        links = {
            "HOME": "/hitstats/home",
            "LINEUP": "/hitstats/team",
            "PAVILION": "/pavilion",
            "LOGOUT": "logout",
        };
    } else if (page === "abr") {
        links = {
            "PAVILION": `/pavilion?user_id=${otherProps?.user_id || ""}`,
            "ALLIANCE BATTLE ROYALE": "/alliance-battle-royale",
        };
    }

    className = className || "";

    if (variant === "mobile") {
        return (
            <div className={`d-block d-md-none ${className}`} style={{ ...(otherProps?.style || {}), zIndex: 9 }}>
                <Mobile_Header {...otherProps} page={page} links={links} onLogout={onLogout} />
            </div>
        );
    } else if (variant === "desktop") {
        return (
            <div className={`d-none d-md-block ${className}`} style={{ ...(otherProps?.style || {}), zIndex: 9 }}>
                <Desktop_Header {...otherProps} page={page} links={links} onLogout={onLogout} />
            </div>
        );
    }

    return (
        <>
            <div className={`d-block d-md-none ${className}`} style={{ zIndex: 9, ...(otherProps?.style || {}) }}>
                <Mobile_Header {...otherProps} page={page} links={links} onLogout={onLogout} />
            </div>

            <div className={`d-none d-md-block ${className}`} style={{ zIndex: 9, ...(otherProps?.style || {}) }}>
                <Desktop_Header {...otherProps} page={page} links={links} onLogout={onLogout} />
            </div>
        </>
    );
}

function Header({ style, maxScrollPosition, forceFixed, ...otherProps }) {
    const navigate = useNavigate();
    let scrollPosition = useScrollPosition();

    const handleLogout = () => {
        localStorage.removeItem("hw_user");
        navigate("/hitstats/login", { replace: true });
    };

    let fixedHeaderStyles = {
        ...style,
        position: "fixed",
        background: "transparent",
        width: "100%",
        top: 0,
        zIndex: 999999,
        boxShadow: "20px 20px 100px rgba(25, 6, 46)",
    };

    const page = otherProps?.page;

    // For HitStats pages
    if (page === "hitstats") {
        // If explicitly forced fixed (e.g., homepage), keep header always visible
        if (forceFixed) {
            return (
                <RenderHeader
                    style={{ ...fixedHeaderStyles, margin: 0 }}
                    {...otherProps}
                    isSticky={true}
                    onLogout={handleLogout}
                />
            );
        }
        // Use CSS sticky to keep one instance with consistent background
        const stickyWrapperStyles = {
            position: "sticky",
            top: 0,
            left: 0,
            right: 0,
            width: "100%",
            zIndex: 999999,
            background: "transparent",
            boxShadow: "20px 20px 100px rgba(25, 6, 46)",
        };
        return (
            <div style={stickyWrapperStyles}>
                <RenderHeader
                    style={{ width: "100%" }}
                    {...otherProps}
                    isSticky={true}
                    onLogout={handleLogout}
                />
            </div>
        );
    }

    // Default behavior (unchanged for other pages)
    return (
        <>
            <RenderHeader
                style={style}
                {...otherProps}
                onLogout={handleLogout}
            />

            {scrollPosition > 50 && (
                <RenderHeader
                    style={fixedHeaderStyles}
                    {...otherProps}
                    isSticky={true}
                    onLogout={handleLogout}
                />
            )}
        </>
    );
}

export default Header;